import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { TrendingDown, Bitcoin, Briefcase, AlertTriangle, UserX, ArrowRight, X, CheckCircle, Clock, Shield, FileText } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const servicesData = {
  ru: [
    {
      id: 'broker',
      icon: TrendingDown,
      image: 'https://images.unsplash.com/photo-1643962579365-3a9222e923b8?w=600&q=80',
      title: 'Возврат средств от брокеров',
      shortDesc: 'Возврат депозитов от нелицензированных и недобросовестных форекс и криптовалютных брокеров',
      fullDesc: 'Мы специализируемся на возврате средств от нелицензированных форекс-брокеров, CFD-платформ и криптовалютных бирж. Наши специалисты имеют многолетний опыт работы с международными регуляторами и платёжными системами.',
      process: [
        'Анализ вашей ситуации и документов',
        'Сбор доказательной базы',
        'Подача жалоб в регулирующие органы',
        'Работа с платёжными системами (chargeback)',
        'Сопровождение через банковские процедуры до результата'
      ],
      stats: { successRate: '92%', avgTime: '2-3 недели', minAmount: '$1,000' },
      cases: ['Forex брокеры без лицензии', 'CFD платформы', 'Бинарные опционы', 'Криптобиржи-скам']
    },
    {
      id: 'crypto',
      icon: Bitcoin,
      image: 'https://images.unsplash.com/photo-1549605659-32d82da3a059?w=600&q=80',
      title: 'Борьба с криптомошенниками',
      shortDesc: 'Возврат средств, похищенных через поддельные криптовалютные платформы и пирамиды',
      fullDesc: 'Криптовалютное мошенничество — одна из самых сложных категорий. Мы используем блокчейн-аналитику, работаем с криптобиржами и правоохранительными органами разных стран для отслеживания и возврата ваших активов.',
      process: [
        'Блокчейн-анализ транзакций',
        'Идентификация кошельков мошенников',
        'Запросы на криптобиржи о заморозке средств',
        'Взаимодействие с правоохранительными органами',
        'Работа с банками и регуляторами в нескольких странах'
      ],
      stats: { successRate: '78%', avgTime: '2-3 недели', minAmount: '$5,000' },
      cases: ['Фейковые криптобиржи', 'ICO/IDO скамы', 'NFT мошенничество', 'DeFi скамы', 'Крипто-пирамиды']
    },
    {
      id: 'investment',
      icon: Briefcase,
      image: 'https://images.unsplash.com/photo-1758520144420-3e5b22e9b9a4?w=600&q=80',
      title: 'Инвестиционные споры',
      shortDesc: 'Разрешение споров с инвестиционными фондами и управляющими компаниями',
      fullDesc: 'Помогаем инвесторам в спорах с управляющими компаниями, хедж-фондами и брокерами. Защищаем ваши права при нарушении инвестиционных договоров, манипуляциях с отчётностью и незаконном управлении активами.',
      process: [
        'Аудит инвестиционной документации',
        'Экспертиза действий управляющей компании',
        'Урегулирование через банковские процедуры',
        'Представительство в арбитраже',
        'Международная работа с регуляторами'
      ],
      stats: { successRate: '85%', avgTime: '1-3 недели', minAmount: '$10,000' },
      cases: ['Хедж-фонды', 'ПАММ-счета', 'Доверительное управление', 'Инвестиционные платформы']
    },
    {
      id: 'pyramid',
      icon: AlertTriangle,
      image: 'https://images.unsplash.com/photo-1719989809483-7bb7f6da9284?w=600&q=80',
      title: 'Возврат из финансовых пирамид',
      shortDesc: 'Помощь жертвам финансовых пирамид и MLM-схем в возврате вложенных средств',
      fullDesc: 'Финансовые пирамиды и MLM-схемы ежегодно обманывают миллионы людей. Мы помогаем жертвам вернуть средства через работу с правоохранительными органами, банками и международную работу с финансовыми регуляторами.',
      process: [
        'Сбор информации о структуре пирамиды',
        'Подача заявлений в правоохранительные органы',
        'Работа с банками по возврату переводов',
        'Участие в коллективных претензиях',
        'Поиск и заморозка активов организаторов'
      ],
      stats: { successRate: '65%', avgTime: '2-3 недели', minAmount: '$2,000' },
      cases: ['Финансовые пирамиды', 'MLM-схемы', 'Хайп-проекты', 'Псевдоинвестиционные фонды']
    },
    {
      id: 'employment',
      icon: UserX,
      image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=600&q=80',
      title: 'Мошенничество при трудоустройстве',
      shortDesc: 'Возврат средств, потерянных из-за мошеннических схем при найме на работу',
      fullDesc: 'Мошенничество при трудоустройстве — растущая проблема. Жертвы теряют деньги на фальшивых вакансиях, предоплатах за "оформление", покупке оборудования или обучающих курсов. Мы помогаем вернуть средства через банковские процедуры и работу с регуляторами.',
      process: [
        'Анализ схемы мошенничества и документов',
        'Сбор доказательной базы (переписка, платежи)',
        'Подача жалоб в регулирующие органы',
        'Инициация chargeback через банк',
        'Работа с платёжными системами по возврату'
      ],
      stats: { successRate: '80%', avgTime: '1-2 недели', minAmount: '$500' },
      cases: ['Фальшивые вакансии', 'Предоплата за трудоустройство', 'Покупка оборудования для работы', 'Платные обучающие курсы-скам', 'Фейковые рекрутинговые агентства']
    }
  ],
  en: [
    {
      id: 'broker',
      icon: TrendingDown,
      image: 'https://images.unsplash.com/photo-1643962579365-3a9222e923b8?w=600&q=80',
      title: 'Broker Fund Recovery',
      shortDesc: 'Recovery of deposits from unlicensed and unscrupulous forex and cryptocurrency brokers',
      fullDesc: 'We specialize in recovering funds from unlicensed forex brokers, CFD platforms, and cryptocurrency exchanges. Our specialists have years of experience working with international regulators and payment systems.',
      process: [
        'Analysis of your situation and documents',
        'Collection of evidence',
        'Filing complaints with regulatory authorities',
        'Working with payment systems (chargeback)',
        'Banking procedure support until results'
      ],
      stats: { successRate: '92%', avgTime: '2-3 weeks', minAmount: '$1,000' },
      cases: ['Unlicensed Forex brokers', 'CFD platforms', 'Binary options', 'Scam crypto exchanges']
    },
    {
      id: 'crypto',
      icon: Bitcoin,
      image: 'https://images.unsplash.com/photo-1549605659-32d82da3a059?w=600&q=80',
      title: 'Crypto Fraud Recovery',
      shortDesc: 'Recovery of funds stolen through fake cryptocurrency platforms and pyramids',
      fullDesc: 'Cryptocurrency fraud is one of the most complex categories. We use blockchain analytics, work with crypto exchanges and law enforcement agencies in different countries to track and recover your assets.',
      process: [
        'Blockchain transaction analysis',
        'Identification of scammer wallets',
        'Requests to crypto exchanges to freeze funds',
        'Interaction with law enforcement',
        'Working with banks and regulators in multiple countries'
      ],
      stats: { successRate: '78%', avgTime: '2-3 weeks', minAmount: '$5,000' },
      cases: ['Fake crypto exchanges', 'ICO/IDO scams', 'NFT fraud', 'DeFi scams', 'Crypto pyramids']
    },
    {
      id: 'investment',
      icon: Briefcase,
      image: 'https://images.unsplash.com/photo-1758520144420-3e5b22e9b9a4?w=600&q=80',
      title: 'Investment Disputes',
      shortDesc: 'Resolution of disputes with investment funds and management companies',
      fullDesc: 'We help investors in disputes with management companies, hedge funds, and brokers. We protect your rights in case of investment contract violations, reporting manipulations, and illegal asset management.',
      process: [
        'Investment documentation audit',
        'Examination of management company actions',
        'Settlement through banking procedures',
        'Arbitration representation',
        'International regulatory work'
      ],
      stats: { successRate: '85%', avgTime: '1-3 weeks', minAmount: '$10,000' },
      cases: ['Hedge funds', 'PAMM accounts', 'Trust management', 'Investment platforms']
    },
    {
      id: 'pyramid',
      icon: AlertTriangle,
      image: 'https://images.unsplash.com/photo-1719989809483-7bb7f6da9284?w=600&q=80',
      title: 'Pyramid Scheme Recovery',
      shortDesc: 'Helping victims of financial pyramids and MLM schemes recover their investments',
      fullDesc: 'Financial pyramids and MLM schemes deceive millions of people every year. We help victims recover funds through work with law enforcement, banks, and international cooperation with financial regulators.',
      process: [
        'Gathering information about pyramid structure',
        'Filing reports with law enforcement',
        'Working with banks to reverse transfers',
        'Participation in collective claims',
        'Search and seizure of organizers\' assets'
      ],
      stats: { successRate: '65%', avgTime: '2-3 weeks', minAmount: '$2,000' },
      cases: ['Financial pyramids', 'MLM schemes', 'HYIP projects', 'Pseudo-investment funds']
    },
    {
      id: 'employment',
      icon: UserX,
      image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=600&q=80',
      title: 'Employment Fraud Recovery',
      shortDesc: 'Recovery of funds lost due to fraudulent employment schemes',
      fullDesc: 'Employment fraud is a growing problem. Victims lose money on fake job offers, upfront payments for "processing", equipment purchases, or scam training courses. We help recover funds through banking procedures and work with regulators.',
      process: [
        'Analysis of the fraud scheme and documents',
        'Collection of evidence (correspondence, payments)',
        'Filing complaints with regulatory authorities',
        'Initiating chargeback through the bank',
        'Working with payment systems for refunds'
      ],
      stats: { successRate: '80%', avgTime: '1-2 weeks', minAmount: '$500' },
      cases: ['Fake job offers', 'Upfront employment fees', 'Equipment purchase scams', 'Scam training courses', 'Fake recruitment agencies']
    }
  ],
  ar: [
    {
      id: 'broker',
      icon: TrendingDown,
      image: 'https://images.unsplash.com/photo-1643962579365-3a9222e923b8?w=600&q=80',
      title: 'استرداد أموال الوسطاء',
      shortDesc: 'استرداد الودائع من وسطاء الفوركس والعملات المشفرة غير المرخصين',
      fullDesc: 'نحن متخصصون في استرداد الأموال من وسطاء الفوركس غير المرخصين ومنصات CFD وبورصات العملات المشفرة.',
      process: [
        'تحليل وضعك ومستنداتك',
        'جمع الأدلة',
        'تقديم شكاوى للجهات الرقابية',
        'العمل مع أنظمة الدفع',
        'الدعم المصرفي حتى النتائج'
      ],
      stats: { successRate: '92%', avgTime: '2-3 أسابيع', minAmount: '$1,000' },
      cases: ['وسطاء فوركس غير مرخصين', 'منصات CFD', 'الخيارات الثنائية', 'بورصات العملات المشفرة']
    },
    {
      id: 'crypto',
      icon: Bitcoin,
      image: 'https://images.unsplash.com/photo-1549605659-32d82da3a059?w=600&q=80',
      title: 'مكافحة احتيال العملات المشفرة',
      shortDesc: 'استرداد الأموال المسروقة عبر منصات العملات المشفرة المزيفة',
      fullDesc: 'احتيال العملات المشفرة من أكثر الفئات تعقيدًا. نستخدم تحليلات البلوكتشين ونعمل مع بورصات العملات المشفرة.',
      process: [
        'تحليل معاملات البلوكتشين',
        'تحديد محافظ المحتالين',
        'طلبات تجميد الأموال',
        'التعاون مع الجهات الأمنية',
        'العمل مع البنوك والجهات الرقابية الدولية'
      ],
      stats: { successRate: '78%', avgTime: '2-3 أسابيع', minAmount: '$5,000' },
      cases: ['بورصات العملات المشفرة المزيفة', 'احتيال ICO/IDO', 'احتيال NFT', 'أهرامات العملات المشفرة']
    },
    {
      id: 'investment',
      icon: Briefcase,
      image: 'https://images.unsplash.com/photo-1758520144420-3e5b22e9b9a4?w=600&q=80',
      title: 'النزاعات الاستثمارية',
      shortDesc: 'حل النزاعات مع صناديق الاستثمار وشركات الإدارة',
      fullDesc: 'نساعد المستثمرين في النزاعات مع شركات الإدارة وصناديق التحوط والوسطاء.',
      process: [
        'تدقيق وثائق الاستثمار',
        'فحص إجراءات شركة الإدارة',
        'التسوية من خلال الإجراءات المصرفية',
        'التمثيل في التحكيم',
        'العمل الدولي مع الجهات الرقابية'
      ],
      stats: { successRate: '85%', avgTime: '1-3 أسابيع', minAmount: '$10,000' },
      cases: ['صناديق التحوط', 'حسابات PAMM', 'إدارة الثقة', 'منصات الاستثمار']
    },
    {
      id: 'pyramid',
      icon: AlertTriangle,
      image: 'https://images.unsplash.com/photo-1719989809483-7bb7f6da9284?w=600&q=80',
      title: 'استرداد من الأهرامات المالية',
      shortDesc: 'مساعدة ضحايا الأهرامات المالية في استرداد استثماراتهم',
      fullDesc: 'الأهرامات المالية ومخططات MLM تخدع الملايين سنويًا. نساعد الضحايا في استرداد أموالهم.',
      process: [
        'جمع معلومات عن هيكل الهرم',
        'تقديم بلاغات للجهات الأمنية',
        'العمل مع البنوك لاسترداد التحويلات',
        'المشاركة في المطالبات الجماعية',
        'البحث عن أصول المنظمين ومصادرتها'
      ],
      stats: { successRate: '65%', avgTime: '2-3 أسابيع', minAmount: '$2,000' },
      cases: ['الأهرامات المالية', 'مخططات MLM', 'مشاريع HYIP', 'صناديق استثمار وهمية']
    },
    {
      id: 'employment',
      icon: UserX,
      image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=600&q=80',
      title: 'احتيال التوظيف',
      shortDesc: 'استرداد الأموال المفقودة بسبب مخططات التوظيف الاحتيالية',
      fullDesc: 'احتيال التوظيف مشكلة متنامية. يخسر الضحايا أموالهم في عروض عمل مزيفة ودفعات مقدمة وشراء معدات ودورات تدريبية احتيالية. نساعد في استرداد الأموال من خلال الإجراءات المصرفية.',
      process: [
        'تحليل مخطط الاحتيال والمستندات',
        'جمع الأدلة (المراسلات، المدفوعات)',
        'تقديم شكاوى للجهات الرقابية',
        'بدء استرداد المبالغ عبر البنك',
        'العمل مع أنظمة الدفع لاسترداد الأموال'
      ],
      stats: { successRate: '80%', avgTime: '1-2 أسابيع', minAmount: '$500' },
      cases: ['عروض عمل مزيفة', 'رسوم توظيف مقدمة', 'شراء معدات للعمل', 'دورات تدريبية احتيالية', 'وكالات توظيف مزيفة']
    }
  ]
};

const ServiceModal = ({ service, isOpen, onClose, t }) => {
  if (!isOpen || !service) return null;

  const scrollToContact = () => {
    onClose();
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 300);
  };

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.7)',
    backdropFilter: 'blur(8px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '16px'
  };

  const modalStyle = {
    background: 'white',
    borderRadius: '24px',
    maxWidth: '700px',
    width: '100%',
    maxHeight: '90vh',
    overflowY: 'auto',
    position: 'relative',
    padding: 'clamp(20px, 5vw, 40px)'
  };

  const modalContent = (
    <div style={overlayStyle} onClick={onClose}>
      <div style={modalStyle} onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} style={{position: 'absolute', top: '20px', right: '20px', background: '#f3f4f6', border: 'none', borderRadius: '50%', width: '44px', height: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'}}>
          <X size={24} />
        </button>
        
        <div className="modal-header" style={{display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px', paddingRight: '50px', flexWrap: 'wrap'}}>
          <div style={{width: '52px', height: '52px', background: 'linear-gradient(135deg, #10B981, #059669)', borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', flexShrink: 0}}>
            <service.icon size={28} />
          </div>
          <h2 style={{fontSize: 'clamp(20px, 4vw, 28px)', fontWeight: 700, color: '#111827', fontFamily: 'Playfair Display, serif', wordBreak: 'break-word'}}>{service.title}</h2>
        </div>

        <p style={{fontSize: '16px', lineHeight: 1.7, color: '#6B7280', marginBottom: '32px'}}>{service.fullDesc}</p>

        <div className="service-modal-stats">
          <div className="service-modal-stat-card">
            <Shield size={20} style={{color: '#10B981', marginBottom: '8px'}} />
            <div style={{fontSize: '12px', color: '#9CA3AF'}}>{t.successProbability || 'Успешность'}</div>
            <div style={{fontSize: 'clamp(18px, 4vw, 24px)', fontWeight: 700, color: '#10B981'}}>{service.stats.successRate}</div>
          </div>
          <div className="service-modal-stat-card">
            <Clock size={20} style={{color: '#10B981', marginBottom: '8px'}} />
            <div style={{fontSize: '12px', color: '#9CA3AF'}}>{t.returnPeriod || 'Срок'}</div>
            <div style={{fontSize: 'clamp(18px, 4vw, 24px)', fontWeight: 700, color: '#10B981'}}>{service.stats.avgTime}</div>
          </div>
          <div className="service-modal-stat-card">
            <FileText size={20} style={{color: '#10B981', marginBottom: '8px'}} />
            <div style={{fontSize: '12px', color: '#9CA3AF'}}>{t.minAmount || 'Мин. сумма'}</div>
            <div style={{fontSize: 'clamp(18px, 4vw, 24px)', fontWeight: 700, color: '#10B981'}}>{service.stats.minAmount}</div>
          </div>
        </div>

        <div style={{marginBottom: '28px'}}>
          <h3 style={{display: 'flex', alignItems: 'center', gap: '10px', fontSize: '18px', fontWeight: 700, color: '#111827', marginBottom: '16px'}}>
            <CheckCircle size={20} style={{color: '#10B981'}} />
            {t.howWeWork || 'Как мы работаем'}
          </h3>
          <ul style={{listStyle: 'none', padding: 0, margin: 0}}>
            {service.process.map((step, index) => (
              <li key={index} style={{display: 'flex', alignItems: 'flex-start', gap: '14px', padding: '12px 0', borderBottom: '1px solid #e5e7eb', fontSize: '15px', color: '#6B7280'}}>
                <span style={{width: '28px', height: '28px', background: 'linear-gradient(135deg, #10B981, #F59E0B)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '13px', fontWeight: 700, color: 'white', flexShrink: 0}}>{index + 1}</span>
                <span>{step}</span>
              </li>
            ))}
          </ul>
        </div>

        <div style={{marginBottom: '28px'}}>
          <h3 style={{display: 'flex', alignItems: 'center', gap: '10px', fontSize: '18px', fontWeight: 700, color: '#111827', marginBottom: '16px'}}>
            <AlertTriangle size={20} style={{color: '#10B981'}} />
            {t.whatWeHandle || 'Что мы решаем'}
          </h3>
          <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px'}}>
            {service.cases.map((caseItem, index) => (
              <span key={index} style={{background: 'rgba(16, 185, 129, 0.1)', border: '1px solid #10B981', color: '#10B981', padding: '8px 16px', borderRadius: '20px', fontSize: '14px', fontWeight: 500}}>{caseItem}</span>
            ))}
          </div>
        </div>

        <button onClick={scrollToContact} style={{width: '100%', padding: '18px 32px', background: 'linear-gradient(135deg, #10B981, #059669)', border: 'none', borderRadius: '12px', fontSize: '17px', fontWeight: 700, color: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px'}}>
          {t.getFreeConsultation || 'Получить бесплатную консультацию'}
          <ArrowRight size={20} />
        </button>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

const ServicesSection = () => {
  const { t, currentLang } = useLanguage();
  const [selectedService, setSelectedService] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const services = servicesData[currentLang] || servicesData.ru;

  const openModal = (service) => {
    setSelectedService(service);
    setIsModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedService(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <section id="services" className="services-section">
      <div className="section-container">
        <div className="section-header centered">
          <h2 className="section-title">{t.servicesTitle}</h2>
          <p className="section-subtitle">{t.servicesSubtitle}</p>
        </div>

        <div className="services-grid">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              {service.image && (
                <div className="service-card-image-wrap">
                  <img src={service.image} alt={service.title} className="service-card-image" loading="lazy" />
                </div>
              )}
              <div className="service-card-content">
                <div className="service-icon-wrapper">
                  <service.icon size={28} />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.shortDesc}</p>
                <button 
                  className="service-link"
                  onClick={() => openModal(service)}
                  data-testid={`service-${service.id}-btn`}
                >
                  {t.learnMore}
                  <ArrowRight size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <ServiceModal 
        service={selectedService}
        isOpen={isModalOpen}
        onClose={closeModal}
        t={t}
      />
    </section>
  );
};

export default ServicesSection;
